'use client';

import { useEffect, useState } from 'react';

const INTERACTION_EVENTS = ['pointermove', 'pointerdown', 'scroll', 'keydown', 'touchstart'] as const;

/**
 * Diventa true alla prima interazione dell'utente oppure `timeoutMs` dopo
 * l'evento load, se prima non è successo nulla. Serve a rimandare risorse
 * pesanti ma non essenziali (Three.js, script di terze parti) fuori dal
 * caricamento iniziale della pagina.
 *
 * Con `mediaQuery` il trigger si attiva solo se la media query corrisponde.
 */
export function useAfterInteraction(timeoutMs: number, mediaQuery?: string) {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    if (mediaQuery && !window.matchMedia(mediaQuery).matches) return;

    let timer: ReturnType<typeof setTimeout> | undefined;
    const trigger = () => {
      cleanup();
      setReady(true);
    };
    const startTimer = () => {
      timer = setTimeout(trigger, timeoutMs);
    };
    function cleanup() {
      clearTimeout(timer);
      window.removeEventListener('load', startTimer);
      INTERACTION_EVENTS.forEach((e) => window.removeEventListener(e, trigger));
    }

    INTERACTION_EVENTS.forEach((e) => window.addEventListener(e, trigger, { once: true, passive: true }));
    if (document.readyState === 'complete') startTimer();
    else window.addEventListener('load', startTimer, { once: true });

    return cleanup;
  }, [timeoutMs, mediaQuery]);

  return ready;
}
